export default __webpack_public_path__ + "static/media/024-strawberry jam.93cb2526.svg";